import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Col,
  Row,
  Card,
  CardText,
  Form,
  CardBody,
} from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import readXlsxFile from "read-excel-file";
import { createHotelImport } from "../../../utils/services/hotel";
import ModeloUpload from "../../../assets/statics/modelo_hotel.xlsx";
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
import ModalExcelRows from "../Voo/ModalExcelRows";
import { allExcelColumns, excelColumnsPtBr } from "./importHotelValidation";
import {
  findRowsWithError,
  getUnregisteredEmails,
} from "../Voo/importValidation";

export default function ImportHotel(props) {
  const { toggleModal, idEvent, data } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [imgError, setImgError] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  const importActivated = useRef(false);

  // modal de erros no arquivo xlsx
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);

  let timerID = null;

  useEffect(() => {
    setselectedFiles([]);
    setImgError("");
  }, []);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
    clearTimeout(timerID);
  }
  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;
    clearTimeout(timerID);
    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      Participante: {
        prop: "login",
        type: String,
      },
      Hotel: {
        prop: "hotel",
        type: String,
      },
      DataCheckIn: {
        prop: "checkindate",
        type: String,
      },
      HoraCheckIn: {
        prop: "checkintime",
        type: String,
      },
      DataCheckOut: {
        prop: "checkoutdate",
        type: String,
      },
      HoraCheckOut: {
        prop: "checkouttime",
        type: String,
      },
      NumeroDaReserva: {
        prop: "reservationnumber",
        type: String,
      },
      Endereco: {
        prop: "address",
        type: String,
      },
      TelefoneDoHotel: {
        prop: "phonenumber",
        type: String,
      },
      InformacoesExtras: {
        prop: "extrainformation",
        type: String,
      },
    };

    let count = 1;

    const readXlsx = async () => {
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumns(row, i));
      const rowsWithError = findRowsWithError(validateRows);

      setTotalRows(validateRows.length);

      // validar colunas se esta no padrão
      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const header = rowsWithoutSchema[0];
      const schemaCreate = Object.keys(schema);

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }

      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
        return;
      }

      const unregisteredEmails = await getUnregisteredEmails(
        validateRows,
        "",
        idEvent
      );

      if (unregisteredEmails.length > 0) {
        setErrors(unregisteredEmails);
        setModalErrors(true);
        return;
      }

      for (const row of validateRows) {
        await importHotelService(row, validateRows.length);
      }
    };

    readXlsx();

    async function importHotelService(row, totalRows) {
      await createHotelImport({
        event: idEvent,
        login: row.login,
        hotel: row.hotel,
        checkindate: row.checkindate,
        checkoutdate: row.checkoutdate,
        checkintime: row.checkintime,
        checkouttime: row.checkouttime,
        reservationnumber: row.reservationnumber,
        address: row.address,
        phonenumber: row.phonenumber,
        extrainformation: row.extrainformation,
        jwt: "",
      })
        .then((e) => {
          if (e.message === "created") {
            setTotalSended(count++);
          }

          if (count === totalRows || (count === 2 && totalRows === 1)) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => {
          setBtnCancel(false);
          console.log("erro", error);
        });
    }
  }

  return (
    <>
      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            data();
            toggleModal();
            setsuccess_dlg(false);
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}

      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBr}
        />
      )}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_hotel.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            <p style={{ color: "red" }}>{imgError}</p>
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Enviar Hotéis
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
